// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.device-table table {
    border: "10px solide black"
}

/* .device-table tbody {
    border-top: 12px solid #eaedeb;
} */

.device-table table td {
    border: none;
}

.device-table table td,
.device-table thead tr th div {
    padding: 12px 16px;
}

.device-table tbody {
    /* border: 6px solid #fff; */
    border-top: 12px solid #eaedeb !important;

    tr {
        height: 60px;
    }

}

.device-table table,
.device-table th,
.device-table td {
    border: none;
}

@media (max-width: 1024px) {
  .device-table table td,
  .device-table thead tr th div {
    padding: 10px;
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .device-table table td,
  .device-table thead tr th div {
    padding: 8px;
    font-size: 12px;
  }
}

.device-table thead {
    tr {
        th {
            padding: 0;
            margin: 0;
            background-color: #eaedeb;

            div {
                background-color: #d0e9ee;
                height: 100%;
                padding-block: 1rem;
                /* box-shadow: rgba(0, 0, 0, 0.2) 2px 2px 4px; */
            }

            &:first-child {
                div {
                    border-bottom-left-radius: 10px;
                    border-top-left-radius: 10px;
                    /* box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
                    margin-left: 2px; */
                }
            }

            &:last-child {
                div {
                    border-bottom-right-radius: 10px;
                    border-top-right-radius: 10px;
                    /* box-shadow: rgba(0, 0, 0, 0.2) 2px 2px 4px; */
                }
            }
        }
    }
}

.device-table tfoot {
    padding-top: 30px;
    background-color: #eaedeb;

    td {
        background: #eaedeb;
        background-color: #eaedeb;
        justify-content: flex-end;
    }
}

/* paper box shadow */
.css-1mbunh-MuiPaper-root {
    box-shadow: none !important;
}

/* search and x icon */
.css-18w7uxr-MuiSvgIcon-root {
    color: rgb(0, 124, 146);
    font-size: 1.5rem !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Devices/Devices.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;;GAEG;;AAEH;IACI,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,yCAAyC;;IAEzC;QACI,YAAY;IAChB;;AAEJ;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;EACE;;IAEE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;IACI;QACI;YACI,UAAU;YACV,SAAS;YACT,yBAAyB;;YAEzB;gBACI,yBAAyB;gBACzB,YAAY;gBACZ,mBAAmB;gBACnB,gDAAgD;YACpD;;YAEA;gBACI;oBACI,+BAA+B;oBAC/B,4BAA4B;oBAC5B;uCACmB;gBACvB;YACJ;;YAEA;gBACI;oBACI,gCAAgC;oBAChC,6BAA6B;oBAC7B,gDAAgD;gBACpD;YACJ;QACJ;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;;IAEzB;QACI,mBAAmB;QACnB,yBAAyB;QACzB,yBAAyB;IAC7B;AACJ;;AAEA,qBAAqB;AACrB;IACI,2BAA2B;AAC/B;;AAEA,sBAAsB;AACtB;IACI,uBAAuB;IACvB,4BAA4B;AAChC","sourcesContent":[".device-table table {\n    border: \"10px solide black\"\n}\n\n/* .device-table tbody {\n    border-top: 12px solid #eaedeb;\n} */\n\n.device-table table td {\n    border: none;\n}\n\n.device-table table td,\n.device-table thead tr th div {\n    padding: 12px 16px;\n}\n\n.device-table tbody {\n    /* border: 6px solid #fff; */\n    border-top: 12px solid #eaedeb !important;\n\n    tr {\n        height: 60px;\n    }\n\n}\n\n.device-table table,\n.device-table th,\n.device-table td {\n    border: none;\n}\n\n@media (max-width: 1024px) {\n  .device-table table td,\n  .device-table thead tr th div {\n    padding: 10px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 768px) {\n  .device-table table td,\n  .device-table thead tr th div {\n    padding: 8px;\n    font-size: 12px;\n  }\n}\n\n.device-table thead {\n    tr {\n        th {\n            padding: 0;\n            margin: 0;\n            background-color: #eaedeb;\n\n            div {\n                background-color: #d0e9ee;\n                height: 100%;\n                padding-block: 1rem;\n                /* box-shadow: rgba(0, 0, 0, 0.2) 2px 2px 4px; */\n            }\n\n            &:first-child {\n                div {\n                    border-bottom-left-radius: 10px;\n                    border-top-left-radius: 10px;\n                    /* box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;\n                    margin-left: 2px; */\n                }\n            }\n\n            &:last-child {\n                div {\n                    border-bottom-right-radius: 10px;\n                    border-top-right-radius: 10px;\n                    /* box-shadow: rgba(0, 0, 0, 0.2) 2px 2px 4px; */\n                }\n            }\n        }\n    }\n}\n\n.device-table tfoot {\n    padding-top: 30px;\n    background-color: #eaedeb;\n\n    td {\n        background: #eaedeb;\n        background-color: #eaedeb;\n        justify-content: flex-end;\n    }\n}\n\n/* paper box shadow */\n.css-1mbunh-MuiPaper-root {\n    box-shadow: none !important;\n}\n\n/* search and x icon */\n.css-18w7uxr-MuiSvgIcon-root {\n    color: rgb(0, 124, 146);\n    font-size: 1.5rem !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
